// Simple mock interview scheduling service backed by localStorage

export type InterviewMode = 'google_meet' | 'ms_teams' | 'zoom' | 'webex' | 'other' | 'no_link' | 'in_person';

export interface InterviewSlot {
  id: string;
  title: string;
  startIso: string;
  endIso: string;
  mode: InterviewMode;
  joinLink?: string;
  location?: string; // for in-person
  capacity: number; // number of candidates allowed
  clientId?: string;
  requirementId?: string;
  panelists: Array<{ name: string; email?: string; userId?: string }>;
  timezone?: string;
  createdByUserId?: string;
}

const STORAGE_KEY = 'recruitedge.interviews.v1';

function loadAll(): InterviewSlot[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function saveAll(slots: InterviewSlot[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(slots));
}

export const InterviewService = {
  list(): InterviewSlot[] {
    return loadAll();
  },

  listByRequirement(requirementId?: string): InterviewSlot[] {
    return loadAll().filter(s => !requirementId || s.requirementId === requirementId);
  },

  create(slot: Omit<InterviewSlot, 'id'>): InterviewSlot {
    const newSlot: InterviewSlot = { id: crypto.randomUUID(), ...slot };
    const slots = loadAll();
    slots.push(newSlot);
    saveAll(slots);
    return newSlot;
  },

  remove(id: string): void {
    const slots = loadAll().filter(s => s.id !== id);
    saveAll(slots);
  }
};


